module.exports = __webpack_public_path__ + "img/mobile.5860ce6d.png";